import {forwardRef, useEffect, useImperativeHandle, useReducer, useRef, useState} from 'react';
import {baseURL} from "@/api";
import {getToken} from 'shj-utils'
import {Button, Col, Form, Input, InputNumber, message, Row, Select, Spin, TreeSelect, Upload,} from 'antd';
import {FileWordOutlined, UploadOutlined} from '@ant-design/icons';
import {isArray, size} from 'lodash-es';
import {SFormUploadImage, SFuncModal, SGeneralForms, SLocalSelected, SLocalTreeSelected} from 'shj-components'
import {bankBranchNumber, bankCardRegRxp, idRegExp, phoneRegExp} from '../../regular';
import {ModalTableDom} from "../modalTable";
import {
  channelLibrarySave,
  channelTypeList,
  findChannelById,
  getChannelCategoryTree,
  getCompanyList,
  getDeptListByCompanyCode,
  getEmployeeSearchByOrgIdList,
  getEnumList,
  getFileUrlPrefix,
} from '@/services/channelManagement'
import {getXTransferInsideTenantId} from '@/utils/common';
import {formatUploadData} from '@/utils/file';
import {trimStr} from "@/utils/data.ts";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {useSetState} from "ahooks";
import {departmentTree} from "@/services/content.ts";

const {Option} = Select;
const TreeNode = TreeSelect.TreeNode;

interface selectObj {
  title: string;
  value: string | number;
  key: string | number;
  setLoading: (v: boolean) => void;
}

export const AddOrEdit = forwardRef((props: any, ref: any) => {
  const formRef = useRef<any>();
  const addRef = useRef<any>({});

  const {id, visibleDrawer, setLoading} = props;
  const [allLoading, setAllLoading] = useState<any>(false);
  const initialValues = {channelExtType: 'NORMAL'};
  const [cooperationOrg, setCooperationOrg] = useState<any>([]); //合作组织
  const [cooperationModeList, setCooperationModeList] = useState<any>([]); //合作方式
  const [cooperationRangeList, setCooperationRangeList] = useState<any>([]); //合作范围
  const [channelCategory, setChannelCategory] = useState<any>([]); //渠道分类
  const [deFileList, setDeFileList] = useState<any>([]);

  const [formData, setFormData] = useState<Record<string, any>>({});

  const [companyList, setCompanyList] = useState<any>([]); // 门店列表
  const [deptList, setDeptList] = useState<any>([]); // 指定部门列表
  const [specifiedRangeList, setSpecifiedRangeList] = useState<any>([]); // 指定人员列表

  const [optionState, setOptionState] = useSetState({
    orgList: [],
    deptList: [],
  })

  const [cardFileList, setCardFileList] = useState<any>({
    idJust: [], //身份证正面
    idBack: [], //身份证反面
    bankCardJust: [], //银行卡正面
    bankCardBack: [], //银行卡反面
  }); // 身份证列表
  // 关系人渠道相关下拉
  const [state, dispatch] = useReducer(
    (_: any, action: any) => {
      return action;
    },
    {
      channelExtTypeList: [], //渠道类型
      typeList: [], //军种
      activePassiveTypeList: [], //主被动属性
      sharePropertyList: [], // 共享属性
      salaryModeList: [], // 薪酬体现
    },
  );
  const {
    typeList,
    channelExtTypeList,
    sharePropertyList,
    salaryModeList,
    activePassiveTypeList,
  } =
    state;

  const reqMeg = '不能为空';
  useEffect(() => {
    if (visibleDrawer) {
      initSelectData();
      initGetForm();
    }
  }, [visibleDrawer]);

  // 是否编辑
  const isEdit = () => {
    return id && id !== '0';
  };

  // 初始化下拉
  const initSelectData = () => {
    getInitOrg();
    loadCooperationMode();
    loadCooperationRange();
    loadChannelCategory();
    Promise.all([
      getEnumeration('com.shj.saas.plus.clue.enums.channel.ChannelExtType'),
      getEnumeration('com.shj.saas.plus.clue.enums.channel.RelatedRelegation'),
      getAllDecoCompany(),
      channelTypeList(),
      getEnumeration('com.shj.saas.plus.clue.enums.channel.RelatePayWay'),
      getEnumeration('com.shj.saas.plus.clue.enums.channel.ActivePassiveType'),
      httpOrgList(),
    ]).then((resp) => {
      const obj = {
        ...state,
        channelExtTypeList: resp[0],
        sharePropertyList: resp[1],
        typeList: resp[3],
        salaryModeList: resp[4],
        activePassiveTypeList: resp[5],
      };
      // if (isEdit()) {
      setCompanyList(resp[2]);
      // }
      dispatch(obj);
      setOptionState({orgList: resp[6]})
    });
  };

  const onChangeOrg = (v) => {
    if (v) {
      departmentTree(v, {
        "direction": "DOWN"
      }).then(res => setOptionState({deptList: res}))
    } else {
      setOptionState({deptList: []})
    }
  }

  // 默认赋值
  const initGetForm = () => {
    setFormData({});
    formRef.current?.onFormRef()?.resetFields();
    setDeFileList([]);
    setCardFileList({
      idJust: [], //身份证正面
      idBack: [], //身份证反面
      bankCardJust: [], //银行卡正面
      bankCardBack: [], //银行卡反面
    });
    if (isEdit()) {
      getInfoById(id);
    } else {
      addRef.current.channelMarkList = [];
    }
  };
  const getInfoById = async (id: string) => {
    setAllLoading(true);
    findChannelById(id)
      .then(async (response) => {
        const data = response;
        const obj = {
          ...data,
          ...data.relateChannel,
        };
        obj.channelCategoryId = `${data.channelCategoryId}`;
        obj.operateCompanyId && onChangeOrg(obj.operateCompanyId)
        // 处理回显
        if (obj.relatedRelegation === 'COMPANY') {
          obj.companyMultiple = obj.relateCompanyIds;
          console.log('obj', obj);
          // ------------- 动态处理门店回显问题 ------------------
          getAllDecoCompany().then((resp) => {
            setCompanyList(resp);
          });
        } else if (obj.relatedRelegation === 'DEPT') {
          obj.companySingle = obj.relateDepartmentInfo.companyId;
          obj.deptList = obj.relateDepartmentInfo.departmentIds;
          console.log('obj', obj)
          // // =========== 动态处理门店回显 ===========
          Promise.all([getAllDecoCompany(), getDeptList(obj.companySingle)]).then((resp) => {
            setCompanyList(resp[0]);
            setDeptList(resp[1]);
          });
        } else if (obj.relatedRelegation === 'PERSON') {
          console.log('obj', obj)
          const companyId = obj.relatePersonInfo.companyId;
          obj.companySingle = companyId;
          obj.relatePersonsList = obj.relatePersonInfo.employeeIds;
          Promise.all([getAllDecoCompany(), getSpecifiedRangeList(companyId)]).then((resp) => {
            setCompanyList(resp[0]);
            setSpecifiedRangeList(resp[1]);
          });
        }
        // 处理文件
        const relatePersonFilesList = obj.relateChannel && obj.relateChannel.relatePersonFiles;
        const objFile: any = {
          idJust: [], //身份证正面
          idBack: [], //身份证反面
          bankCardJust: [], //银行卡正面
          bankCardBack: [], //银行卡反面
        };
        const url = await getFileUrlPrefix();
        if (obj.channelExtType === 'RELATED' && Array.isArray(relatePersonFilesList)) {
          relatePersonFilesList.map((item: any) => {
            item.uid = item.id;
            item.name = item.fileName;
            item.status = 'done';
            item.url = item.filePath?.includes('http') ? item.filePath : (url + item.filePath);
            if (item.name === '身份证正面') {
              objFile.idJust.push(item);
            } else if (item.name === '身份证反面') {
              objFile.idBack.push(item);
            } else if (item.name === '银行卡正面') {
              objFile.bankCardJust.push(item);
            } else if (item.name === '银行卡反面') {
              objFile.bankCardBack.push(item);
            }
          });
          setCardFileList(objFile);
        }
        if (data.contractTemplate) {
          setDeFileList([
            {
              name: '合同模板',
              status: 'done',
              // url: url + data.contractTemplate,
              url: data.contractTemplate, // 后端改动不需要拼接
            },
          ]);
        }
        formRef.current?.onFormRef()?.setFieldsValue({...obj, ...objFile});
        const newInfo = {...obj, ...objFile};
        console.log('newInfo', newInfo);
        setFormData(newInfo);
        setAllLoading(false);
      })
      .catch((e) => {
        console.log('e', e);
        setAllLoading(false);
      });
  };

  // 获取所有的门店
  const getAllDecoCompany = () => {
    return getCompanyList();
  };

  //请求合作组织下拉框内容
  const getInitOrg = () => {
    getCompanyList().then((data) => {
      const allList = [{title: '全部组织', value: '0', key: '0', children: []}];
      const list = data;
      const allKey: string[] = [];
      list.forEach((item: any) => {
        const {name, id} = item;
        const obj_: selectObj = {title: name, value: `${id}`, key: `${id}`};
        allList[0].children.push(obj_);
        allKey.push(id);
      });
      addRef.current.orgAllKey = allKey;
      setCooperationOrg(allList);
    });
  };

  //数据字典获取合作方式
  const loadCooperationMode = () => {
    getEnums('plus-clue', 'com.shj.saas.plus.clue.enums.channel.CooperationMode')
      .then((data) => {
        setCooperationModeList(data);
      });
  };

  //数据字典获取合作范围
  const loadCooperationRange = () => {
    getEnums('plus-clue', 'com.shj.saas.plus.clue.enums.channel.CooperationRange')
      .then((data) => {
        setCooperationRangeList(data);
      });
  };

  // 枚举
  const getEnumeration = (path: string) => getEnumList(path);

  //获取渠道分类下拉框数据
  const loadChannelCategory = () => {
    getChannelCategoryTree()
      .then((data) => {
        const list: any = [{object: {categoryName: '顶级节点', id: 0, enabled: false}, children: []}];
        list[0].children = data;
        setChannelCategory(list);
      })
  };
  // 渠道分类render
  const renderTreeNodes = (data = []) => {
    return data.map((item: any) => {
      if (item.children) {
        return (
          <TreeNode title={item.object.categoryName} key={item.object.id} value={item.object.id + ''}
                    disabled={true}>
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          title={item.object.categoryName}
          key={item.object.id}
          value={item.object.id + ''}
          disabled={!item.object.enabled}
        />
      );
    });
  };
  // 数据验证
  const verificationData = (newValues: any) => {
    const data = {...newValues};
    if (parseInt(newValues.costRangeStart, 10) > parseInt(newValues.costRangeEnd, 10)) {
      message.error('请填写正确格式的费用区间');
      return false;
    }
    if (newValues.channelExtType === 'RELATED') {
      const {idJust, idBack, bankCardJust, bankCardBack} = newValues;
      if (!idJust.length || (!idJust[0].filePath && !idJust[0].url)) {
        message.warning('请检查身份证正面是否上传完毕');
        return;
      } else {
        data.idJust = [{filePath: idJust[0].filePath || idJust[0].url, fileName: '身份证正面', fileType: 'IDCARD'}];
      }
      if (!idBack.length || (!idBack[0].filePath && !idBack[0].url)) {
        message.warning('请检查身份证反面是否上传完毕');
        return;
      } else {
        data.idBack = [{filePath: idBack[0].filePath || idBack[0].url, fileName: '身份证反面', fileType: 'IDCARD'}];
      }
      if (!bankCardJust.length || (!bankCardJust[0].filePath && !bankCardJust[0].url)) {
        message.warning('请检查银行卡正面是否上传完毕');
        return;
      } else {
        data.bankCardJust = [{
          filePath: bankCardJust[0].filePath || bankCardJust[0].url,
          fileName: '银行卡正面',
          fileType: 'bankCardJust'
        }];
      }
      if (!bankCardBack.length || (!bankCardBack[0].filePath && !bankCardBack[0].url)) {
        message.warning('请检查银行卡反面是否上传完毕');
        return;
      } else {
        data.bankCardBack = [{
          filePath: bankCardBack[0].filePath || bankCardBack[0].url,
          fileName: '银行卡反面',
          fileType: 'bankCardJust'
        }];
      }
    }
    console.log('数据验证:::', data);
    return data;
  };
  // 数据处理
  const dataDispose = (values: any) => {
    const newValues = {...values};
    const {channelMarkList} = addRef.current
    if (isEdit()) newValues.id = id;
    newValues.costRangeStart = parseInt(values.costRangeStart);
    newValues.costRangeEnd = parseInt(values.costRangeEnd);

    // 处理渠道标记
    if (!isEdit()) {
      if (isArray(channelMarkList) && channelMarkList.length > 0) {
        newValues.channelMarkList = [...channelMarkList];
      }
    } else {
      delete newValues.channelMarkList;
    }
    // 关系人相关-归属门店
    if (newValues.companyMultiple) {
      newValues.relateCompanyIds = newValues.companyMultiple;
      delete newValues.companyMultiple;
    }
    // 关系人相关-归属部门
    if (newValues.companySingle) {
      if (newValues.relatedRelegation === 'DEPT') {
        newValues.relateDepartmentInfo = {
          companyId: newValues.companySingle,
          departmentIds: newValues.deptList
        };
        delete newValues.deptList;
      }
      if (newValues.relatedRelegation === 'PERSON') {
        newValues.relatePersonInfo = {
          companyId: newValues.companySingle,
          employeeIds: newValues.relatePersonsList
        };
        delete newValues.relatePersonsList;
      }

      delete newValues.companySingle;
    }

    newValues.relateChannel = {};
    const relateChannelStr = [
      'relatedRelegation',
      'payWay',
      'payValue',
      'relatedName',
      'relatedPhone',
      'relatedIdCard',
      'relatedBankCard',
      'relatedAccountBank',
      'bankBranch',
      'bankAddr',
      'bankBranchNo',
      'relatePersonFiles',
      'relateCompanyIds',
      'relateDepartmentInfo',
      'relatePersonInfo',
    ];

    relateChannelStr.map((item) => {
      newValues.relateChannel[item] = newValues[item];
    });
    Object.keys(newValues).forEach((key) => {
      relateChannelStr.map((item) => {
        if (item == key) {
          delete newValues[item];
        }
      });
    });
    // 处理文件上传
    if (newValues.channelExtType === 'RELATED') {
      const {idJust, idBack, bankCardJust, bankCardBack} = newValues;
      const fileArray = [idJust[0], idBack[0], bankCardJust[0], bankCardBack[0]];
      const fileList: {
        fileName: any;
        filePath: any;
        fileType: any
      }[] = [];
      fileArray.map((item: {
        fileName: any;
        filePath: any;
        fileType: any
      }) => {
        const {fileName, filePath, fileType} = item;
        fileList.push({fileName, filePath, fileType});
      });
      newValues.relateChannel.relatePersonFiles = fileList;
      delete newValues.idJust;
      delete newValues.idBack;
      delete newValues.bankCardJust;
      delete newValues.bankCardBack;
    }
    if (newValues.channelCategoryId) {
      newValues.channelCategoryId = newValues.channelCategoryId + ''
    }
    return newValues;
  };

  // 上传合同
  const handleChange = (info: any) => {
    const {file, fileList} = info;
    setDeFileList(fileList);
    switch (file.status) {
      case 'done':
        formRef.current?.onFormRef()?.setFieldsValue({contractTemplate: file.response.data.fileUrl});
        setDeFileList(info.fileList);
        break;
      default:
        formRef.current?.onFormRef()?.setFieldsValue({contractTemplate: ''});
    }
  };

  // 根据门店获取部门
  const getDeptList = (code: string) => {
    if (code) {
      return getDeptListByCompanyCode(code).then((data: Record<string, any>) => {
        const removalDeptList: {
          code: string | number
        }[] = []; // 部门去重门店相同的code值
        const deptList = data;
        deptList.map((item: {
          code: string | number
        }) => {
          if (item.code != code) {
            removalDeptList.push(item);
          }
        });
        setDeptList(removalDeptList);
        return removalDeptList;
      });
    }
    return [];
  };
  // 去重
  const duplicateRemoval = (array: string | any[], key: string) => {
    const result = [];
    const obj = {};
    for (let i = 0; i < array.length; i++) {
      if (!obj[array[i][key]]) {
        result.push(array[i]);
        obj[array[i][key]] = true;
      }
    }
    return result;
  };
  // 根据门店获取指定人员
  const getSpecifiedRangeList = (companyId: string) => {
    if (companyId) {
      return getEmployeeSearchByOrgIdList(companyId)
        .then((data) => {
          let list: {
            code: string | number
          }[] = [];
          try {
            if (data) {
              data.forEach((item: any) => {
                item.relatePersons = item.userName + (item.workNumber ? '-' + item.workNumber : '');
              });
              const newArr = duplicateRemoval(data, 'relatePersons'); // 去重处理
              list = newArr;
            }
            setSpecifiedRangeList(list);
          } catch (error) {
            setSpecifiedRangeList([]);
          }
          return list;
        })
        .catch(() => {
          return [];
        });
    }
    return [];
  };

  // 上传身份证
  // 判断文件类型
  // const beforeUpload = (file: any) => {
  //   const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
  //   if (!isJpgOrPng) {
  //     message.error('仅支持上传图片格式：jpg/jpeg/png');
  //   }
  //   return isJpgOrPng;
  // };
  const changeUploadImg = (info: any, fileName: string, fileType: string, listName: string) => {
    console.log('changeUploadImg::', info);
    const file = isArray(info) ? info?.[0] : info?.file;
    const newFile: any = {};
    if (file && file.url) {
      newFile.filePath = file.url;
      newFile.fileName = fileName;
      newFile.fileType = fileType;
    }
    // 处理格式
    const newList = [];
    //  && (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg')
    if (newFile && newFile.filePath) {
      newList.push(newFile);
      formRef.current?.onFormRef()?.setFieldValue(listName, [{...file, ...newFile}])
    } else {
      formRef.current?.onFormRef()?.setFieldValue(listName, undefined)
    }
    const obj = {...cardFileList};
    obj[listName] = newList;
    setCardFileList(obj);
  };

  const onAddMark = () => {
    const fn = (newList?) => {
      if (!isEdit()) addRef.current.channelMarkList = newList
    };

    SFuncModal({
      title: '渠道标记',
      footer: null,
      width: 800,
      styles: {
        body: {
          paddingTop: '6px',
          borderTop:'1px solid #f0f0f0'
        },
      },
      content: <ModalTableDom fn={fn}
                              data={{markType: !isEdit() && 'addMark', id: isEdit() && id}}
                              tableData={!isEdit() ? addRef.current?.channelMarkList || [] : undefined}
      />,
    });
  };

  // 渠道类型为关系人渠道
  const isRelated = () => formData.channelExtType === 'RELATED';
  const isPercent = () => formData.payWay === 'PERCENT';
  const isFixed = () => formData.payWay === 'FIXED';
  const isCompany = () => formData.relatedRelegation === 'COMPANY';
  const isDept = () => formData.relatedRelegation === 'DEPT';
  const isPerson = () => formData.relatedRelegation === 'PERSON';

  // 提交
  const onFinish = () => {
    formRef.current?.onFormRef().validateFields().then(values => {
      setLoading(true);
      let newValues = verificationData(values);
      if (!size(newValues)) return;
      newValues = dataDispose(newValues);
      console.log('onFinish:::', newValues);
      channelLibrarySave({data: {...newValues, id: isEdit() ? id : undefined}})
        .then(() => {
          message.success('操作成功', 6);
          props.onClose?.();
        })
        .finally(() => setLoading(false));
    })
  };

  useImperativeHandle(ref, () => ({
    onFinish,
    onReset: () => {
      formRef.current?.onFormRef()?.resetFields();
      // formRef.current?.onFormRef()?.setFieldsValue(formData);
    }
  }), [id]);

  const uploadFileUrl = baseURL + `file-web/file/upload`;

  const onValuesChange = (_: any, allValue: any) => {
    if (allValue.channelExtType === 'RELATED') {
      formRef.current?.onFormRef()?.setFieldsValue({relatedAlias: allValue.channelName});
    }
    setFormData(allValue);
  };

  // @ts-ignore
  return (
    <Spin spinning={allLoading}>
      <SGeneralForms
        ref={formRef}
        initialValues={initialValues}
        formConfig={{onValuesChange}}
        layout={'vertical'}
        configs={[
          {
            layoutRowStyle: { padding:'0px'},
            formItem: [
              {
                name: 'channelName',
                label: '渠道名称',
                required: true,
                spanCol: 12,
                comConfig: {
                  showCount: true,
                  maxLength: 20,
                  onChange: (v) => formRef.current?.onFormRef().setFieldValue('channelName', trimStr(v.target.value))
                }
              },
              {
                label: '渠道标记',
                spanCol: 12,
                children: <div><Button onClick={() => onAddMark()}>新增编码</Button></div>
              },
              {
                name: 'orgIds',
                label: '适用分公司',
                spanCol: 24,
                children: <SLocalTreeSelected showCheckedStrategy={'SHOW_PARENT'}
                                              fieldNames={{label: 'title', value: 'value'}}
                                              treeCheckable={true}
                                              treeData={cooperationOrg}/>
              },
              {
                name: 'cooperateMode',
                label: '合作方式',
                required: true,
                spanCol: 12,
                children: <SLocalSelected optionsData={cooperationModeList}
                                          configData={{label: 'description', value: 'key'}}/>
              },
              // {
              //   name: 'cooperateRange',
              //   label: '合作范围',
              //   required: true,
              //   spanCol: 12,
              //   children: <SLocalSelected optionsData={cooperationRangeList}
              //                             configData={{label: 'description', value: 'key'}}/>
              // },
              {
                name: 'channelCategoryId',
                label: '渠道分类',
                spanCol: 12,
                required: true,
                children: <TreeSelect placeholder={'请选择渠道分类'} showSearch
                                      treeNodeFilterProp="title"
                                      treeDefaultExpandAll={true}>{renderTreeNodes(channelCategory)}</TreeSelect>
              },
              {
                name: 'typeId',
                label: '军种',
                spanCol: 12,
                required: true,
                children: <SLocalSelected optionsData={typeList}
                                          configData={{label: 'typeName', value: 'id'}}/>
              },
              {
                name: 'activePassiveType',
                label: '主被动属性',
                spanCol: 12,
                required: true,
                children: <SLocalSelected optionsData={activePassiveTypeList}
                                          configData={{label: 'description', value: 'key'}}/>
              },
              // {
              //   label: '费用区间',
              //   spanCol: 12,
              //   children: <Row>
              //     <Col span={11}>
              //       <Form.Item noStyle name={'costRangeStart'}>
              //         <InputNumber style={{width: '100%'}} min={1} max={999999999} placeholder={'最小'}/>
              //       </Form.Item>
              //     </Col>
              //     <Col span={2}>
              //       <span style={{
              //         display: 'inline-block',
              //         width: '100%',
              //         textAlign: 'center'
              //       }}>~</span>
              //     </Col>
              //     <Col span={11}>
              //       <Form.Item noStyle name={'costRangeEnd'}>
              //         <InputNumber style={{width: '100%'}} min={1} max={999999999} placeholder={'最大'}/>
              //       </Form.Item>
              //     </Col>
              //   </Row>
              // },
              {
                name: 'stateName',
                label: '当前状态',
                spanCol: 12,
                isHideItem: !isEdit(),
                comConfig: {
                  disabled: true,
                }
              },
              // {
              //   name: 'description',
              //   label: '渠道介绍',
              //   spanCol: 24,
              //   children: <Input placeholder={'请输入渠道介绍'} autoSize={{minRows: 1, maxRows: 5}} showCount maxLength={600}/>
              // },
              // {
              //   name: 'advantage',
              //   label: '渠道优势',
              //   spanCol: 24,
              //   children: <Input placeholder={'请输入渠道优势'} autoSize={{minRows: 1, maxRows: 5}} showCount maxLength={600}/>
              // },
              // {
              //   name: 'disadvantage',
              //   label: '渠道劣势',
              //   spanCol: 24,
              //   children: <Input placeholder={'请输入渠道劣势'} autoSize={{minRows: 1, maxRows: 5}} showCount maxLength={600}/>
              // },
              // {
              //   name: 'suggest',
              //   label: '投放建议',
              //   spanCol: 24,
              //   children: <Input placeholder={'请输入投放建议'} autoSize={{minRows: 1, maxRows: 5}} showCount maxLength={600}/>
              // },
              // {
              //   name: 'hasCooperationAgreement',
              //   required: true,
              //   label: '是否有合作协议',
              //   spanCol: 12,
              //   children: <SLocalSelected
              //     optionsData={[{label: '是', value: true}, {label: '否', value: false}]}/>
              // },
              // {
              //   name: 'contractTemplate',
              //   label: '合同模板',
              //   spanCol: 12,
              //   required: formRef.current?.onFormRef()?.getFieldValue('hasCooperationAgreement') == '1',
              //   children: <Upload
              //     fileList={deFileList}
              //     action={uploadFileUrl}
              //     headers={{
              //       "Authorization": getToken(),
              //       'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId()
              //     }}
              //     listType="text"
              //     iconRender={() => <FileWordOutlined/>}
              //     onChange={handleChange}
              //     onDownload={() => {
              //     }}
              //     maxCount={1}
              //     name="file"
              //   >
              //     <Button icon={<UploadOutlined/>}>上传合同模板</Button>
              //   </Upload>
              // },
              {
                name: 'channelExtType',
                label: '渠道类型',
                spanCol: 12,
                required: true,
                children: <SLocalSelected optionsData={channelExtTypeList}
                                          configData={{label: 'description', value: 'key'}}/>
              },
              {
                name: 'taxRate',
                label: '渠道税率(%)',
                spanCol: 12,
                children: <Row>
                  <Col span={24}>
                    <Form.Item noStyle name={'taxRate'}>
                      <InputNumber placeholder={'请输入渠道税率'} style={{width: '100%'}}/>
                    </Form.Item>
                  </Col>
                </Row>
              },
              {
                name: 'operateCompanyId',
                label: '运营分公司',
                spanCol: 12,
                required: true,
                type: 'select',
                comConfig: {
                  options: optionState.orgList,
                  fieldNames: {label: 'name', value: 'id'},
                  onChange: onChangeOrg
                }
              },
              {
                name: 'operateOrgId',
                label: '运营部门',
                spanCol: 12,
                required: true,
                type: 'tree',
                comConfig: {
                  treeData: optionState.deptList,
                  fieldNames: {label: 'label', value: 'id'},
                  notFoundContent: '请选择公司或无匹配数据',
                }
              },
            ],
          },
          {
            title: isRelated() && '关系人渠道',
            formItem: isRelated() ? [
              {
                name: 'relatedRelegation',
                label: '共享属性',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                children: <SLocalSelected
                  optionsData={sharePropertyList}
                  onChange={() => formRef.current?.onFormRef()?.setFieldsValue({
                    companySingle: null, // 清空数据
                    companyMultiple: [] // 清空数据
                  })}
                  configData={{label: 'description', value: 'key'}}/>
              },
              {
                name: 'payWay',
                label: '薪酬体现',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                children: <Select
                  placeholder={'请选择薪酬体现'}
                  // onChange={(v: string) => setFormData({...formData, payWay: v})}
                >
                  {isArray(salaryModeList) &&
                    salaryModeList.length > 0 &&
                    salaryModeList.map((item: any) => (
                      <Option key={item.key} value={item.key}>
                        {item.description}
                      </Option>
                    ))}
                </Select>
              },
              {
                name: 'payValue',
                label: '提点(%)',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                isHideItem: !isPercent(),
                rules: [
                  {
                    required: true,
                    message: '提点比例为数字且最多保留两位小数',
                    pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                  },
                ]
              },
              {
                name: 'payValue',
                label: '固定薪酬(元)',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                isHideItem: !isFixed(),
              },
              {
                name: 'companyMultiple',
                label: '选择门店',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                isHideItem: !isCompany(),
                children: <SLocalSelected placeholder={'请选择门店'} optionsData={companyList}
                                          mode="multiple"
                                          configData={{label: 'name', value: 'id'}}/>
              },
              {
                name: 'companySingle',
                label: '选择门店',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                isHideItem: !(isDept() || isPerson()),
                children: <SLocalSelected placeholder={'请选择门店'} optionsData={companyList}
                                          onChange={(v: string) => {
                                            if (formData.relatedRelegation === 'PERSON') {
                                              getSpecifiedRangeList(v);
                                              formRef.current?.onFormRef()?.setFieldsValue({relatePersonsList: []}); // 清空操作
                                            } else {
                                              getDeptList(v);
                                              formRef.current?.onFormRef()?.setFieldsValue({deptList: []}); // 切换门店 始终清空部门数据
                                            }
                                          }}
                                          configData={{label: 'name', value: 'id'}}/>
              },
              {
                name: 'deptList',
                label: '选择指定部门',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                isHideItem: (!isDept() || isPerson()),
                children: <SLocalSelected placeholder={'请选择指定部门'} optionsData={deptList}
                                          mode="multiple"
                                          configData={{label: 'departmentName', value: 'id'}}/>
              },
              {
                name: 'relatePersonsList',
                label: '选择指定人员',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                isHideItem: !isPerson(),
                children: <SLocalSelected placeholder={'请选择指定人员'} optionsData={specifiedRangeList}
                                          mode="multiple"
                                          configData={{label: 'relatePersons', value: 'id'}}/>
              },
              {
                name: 'relatedName',
                label: '关系人姓名',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                maxLength: 10,
                comConfig:{
                  onChange:(e) => formRef.current?.onFormRef()?.setFieldValue('relatedName', trimStr(e.target.value))
                }
              },
              {
                name: 'relatedPhone',
                label: '关系人-电话号码',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                rules: [{required: true, message: '关系人-电话号码格式错误', pattern: phoneRegExp}],
              },
              {
                name: 'relatedIdCard',
                label: '关系人-身份证号码',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                rules: [{required: true, message: '关系人-身份证号码格式错误', pattern: idRegExp}],
              },
              {
                name: 'relatedBankCard',
                label: '关系人-银行账户',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                rules: [{required: true, message: '关系人-银行账户格式错误', pattern: bankCardRegRxp}],
              },
              {
                name: 'relatedAccountBank',
                label: '关系人-开户行',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                maxLength: 30,
                rules: [{required: true, message: reqMeg}],
                comConfig:{
                  onChange:(e) => formRef.current?.onFormRef()?.setFieldValue('relatedAccountBank', trimStr(e.target.value))
                }
              },
              {
                name: 'bankBranch',
                label: '关系人-银行网点',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                maxLength: 30,
                rules: [{required: true, message: reqMeg}],
                comConfig:{
                  onChange:(e) => formRef.current?.onFormRef()?.setFieldValue('bankBranch', trimStr(e.target.value))
                }
              },
              {
                name: 'bankAddr',
                label: '关系人-开户行地址',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                maxLength: 30,
                rules: [{required: true, message: reqMeg}],
                comConfig:{
                  onChange:(e) => formRef.current?.onFormRef()?.setFieldValue('bankAddr', trimStr(e.target.value))
                }
              },
              {
                name: 'bankBranchNo',
                label: '关系人-银行网点联行号',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                maxLength: 30,
                rules: [{required: true, message: '关系人-银行网点联行号格式错误', pattern: bankBranchNumber}],
              },
            ] : [],
          },
          {
            formItem: isRelated() ? [
              {
                name: 'idJust',
                label: '身份证正面',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                children: <SFormUploadImage
                  accept={'.jpg,.jpeg,.png'}
                  limit={1}
                  url={uploadFileUrl}
                  setFileUrl={formatUploadData}
                  onChange={(info) => changeUploadImg(info, '身份证正面', 'IDCARD', 'idJust')}
                />
              },
              {
                name: 'idBack',
                label: '身份证反面',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                children: <SFormUploadImage
                  accept={'.jpg,.jpeg,.png'}
                  limit={1}
                  url={uploadFileUrl}
                  setFileUrl={formatUploadData}
                  onChange={(info) => changeUploadImg(info, '身份证反面', 'IDCARD', 'idBack')}
                />
              },
              {
                name: 'bankCardJust',
                label: '银行卡正面',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                children: <SFormUploadImage
                  accept={'.jpg,.jpeg,.png'}
                  limit={1}
                  url={uploadFileUrl}
                  setFileUrl={formatUploadData}
                  onChange={(info) => changeUploadImg(info, '银行卡正面', 'bankCardJust', 'bankCardJust')}
                />
              },
              {
                name: 'bankCardBack',
                label: '银行卡反面',
                layout: 'vertical',
                spanCol: 12,
                required: true,
                children: <SFormUploadImage
                  accept={'.jpg,.jpeg,.png'}
                  limit={1}
                  url={uploadFileUrl}
                  setFileUrl={formatUploadData}
                  onChange={(info) => changeUploadImg(info, '银行卡反面', 'bankCardJust', 'bankCardBack')}
                />
              }
            ] : []
          }
        ]}
      />
    </Spin>
  );
});
